// src/pages/Signup.jsx

import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Snackbar,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import API from "../api";

const Signup = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    mobile: "",
    referralCode: "",
  });
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const navigate = useNavigate();

  const show = (message, severity = "error") => {
    setSnack({ open: true, message, severity });
  };

  const handleSignup = async () => {
    const { name, email, password, mobile } = form;
    if (!name || !email || !password || !mobile) {
      return show("Name, email, password & mobile are required", "warning");
    }
    try {
      await API.post("/signup", form);
      show("Code sent! Please verify your email.", "success");
      setTimeout(() => {
        navigate(`/verify-email?email=${encodeURIComponent(email)}`);
      }, 800);
    } catch (err) {
      show(err.response?.data?.message || "Signup failed");
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f5f5f5"
    >
      <Paper elevation={4} sx={{ p: 4, width: 360 }}>
        <Typography variant="h5" align="center" mb={2}>
          Sign Up
        </Typography>

        <TextField
          fullWidth
          label="Name"
          value={form.name}
          onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          label="Email"
          type="email"
          value={form.email}
          onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          label="Password"
          type="password"
          value={form.password}
          onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          label="Mobile"
          value={form.mobile}
          onChange={(e) => setForm((f) => ({ ...f, mobile: e.target.value }))}
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          label="Referral Code (optional)"
          value={form.referralCode}
          onChange={(e) =>
            setForm((f) => ({ ...f, referralCode: e.target.value }))
          }
          sx={{ mb: 3 }}
        />

        <Button fullWidth variant="contained" onClick={handleSignup}>
          Sign Up
        </Button>

        <Box textAlign="center" mt={2}>
          <Typography
            sx={{ cursor: "pointer", color: "primary.main" }}
            onClick={() => navigate("/login")}
          >
            Already have an account? Log in
          </Typography>
        </Box>
      </Paper>

      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
      >
        <Alert severity={snack.severity}>{snack.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default Signup;
